

export class ExpenseTypeAddInput implements IExpenseTypeAddInput {
    /** The expense type name with 255 character limit */
    expenseTypeName!: string;

    constructor(data?: IExpenseTypeAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeName = _data["expenseTypeName"];
        }
    }

    static fromJS(data: any): ExpenseTypeAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeName"] = this.expenseTypeName;
        return data; 
    }
}

export interface IExpenseTypeAddInput {
    /** The expense type name with 255 character limit */
    expenseTypeName: string;
}

